import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after { box-sizing: border-box; }

  html, body, #root { height: 100%; }

  body {
    margin: 0;
    font-family: ${props => props.theme.typography.family};
    color: ${props => props.theme.palette.textPrimary};
    background: ${props => props.theme.palette.background};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    font-weight: ${props => props.theme.typography.weights.bold};
    line-height: 1.2;
    color: ${props => props.theme.palette.textPrimary};
  }

  p { margin: 0; }
  a { color: inherit; text-decoration: none; }
  button { font-family: inherit; }
    /* Reserve space for fixed header by default; when announcement present
      the .has-announcement body class will increase this padding. */
  main {
    padding-top: 80px; /* header height */
  }

  body.has-announcement main {
    padding-top: 120px; /* announcement + header */
  }

  @media (max-width: 768px) {
    main {
      padding-top: 56px; /* mobile header */
    }
    body.has-announcement main {
      padding-top: 100px; /* mobile announcement + header */
    }
  }
`;

export default GlobalStyle;
